/** Товар каталога для карточки и модального окна */
export interface SiteCatalogProduct {
  id: number
  name: string
  slug: string | null
  description: string | null
  price: number
  quantity: number
  imageUrls: string[]
  imageUrl: string | null
  inStock: boolean
}

export interface SiteCartLine {
  id: number
  productId: number
  quantity: number
  lineTotal: number
  product: {
    id: number
    name: string
    slug: string | null
    price: number
    imageUrl: string | null
    stockQuantity: number
  }
}

export interface SiteCartSnapshot {
  count: number
  total: number
  items: SiteCartLine[]
}

export const emptySiteCart = (): SiteCartSnapshot => ({
  count: 0,
  total: 0,
  items: [],
})
